import { color as Color } from '@starrez/starryui9';
import * as React from 'react';
import styled, { keyframes } from 'styled-components';

const rotateSpinner = keyframes`
    100% { transform: rotate(360deg); }
`;

const SpinnerSpan = styled.span<ISpinnerStyle>`
    height: ${(prop) => prop.size};
    width: ${(prop) => prop.size};
    border: ${(prop) => prop.borderSize} solid ${(prop) => prop.color};
    border-right-color: transparent;
    transform: rotate(0);
    border-radius: 50%;
    animation: ${rotateSpinner} 1.5s ease-in-out 0s infinite;
    display: inline-block;
`;

interface ISpinnerStyle {
    size: string;
    color: string;
    borderSize: string;
}

export interface ISpinnerProps {
    size?: string;
    color?: string;
    borderSize?: string;
}

export const Spinner = ({ size = '20px', color = Color.Grey.G60, borderSize = '1px' }: ISpinnerProps) => (
    <SpinnerSpan size={size} color={color} borderSize={borderSize} />
);
